import XLSX from 'xlsx';
import html2pdf from 'html2pdf.js'

export default {
    methods: {
        serviciosMultiples() {
            return this.dataMultiple.afiliacion_pendientes.multiple_servicios.filter(list => list.name === 'Afp' || list.name === 'Eps' || list.name === 'Ccf' || list.name === 'Riesgo')
        },
        filterSelects(list) {
            return _.filter(this.lists[list], ['id_list_estado', 1])
        },
        async getLimpiar() {
            this.filter = {
                    name: null,
                    id_list: null,
                    id_datos_razon: null,
                    id_datos_asesor: null,
                    id_datos_contacto: null,
                    estado: ['Nuevo', 'Activo', 'Retiro']
                }
                // frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
        },
        async openExcell() {
            this.statusDescargar = false
            this.statusLoading = true
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            dataRoute.servicios = []
            for (let i = 0; i < filterKeys.length; i++) {
                if (this.filter[filterKeys[i]] !== '' && this.filter[filterKeys[i]] !== null) {
                    switch (filterKeys[i]) {
                        case 'name':
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].name])
                            break
                        case 'id_list':
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                        case 'estado':
                            dataRoute.estado = this.filter[filterKeys[i]]
                            break
                        default:
                            others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                    }
                }
            }
            dataRoute.others = others
            dataRoute.mes = this.mes.id
            dataRoute.ano = this.ano.id
            let dataPostArray = await this.getData({ route: 'get_excelllistados', data: dataRoute })
            this.statusLoading = false
            let dataToExport = []
            if (dataPostArray.length > 0) {
                for (let i = 0; i < dataPostArray.length; i++) {

                    let epsExcell = ''
                    let riesgoExcell = ''
                    let ccfExcell = ''
                    let afpExcell = ''
                    let trasladoExcell = ''
                    let otrosExcell = ''
                    let valorExcell = 0

                    for (let j = 0; j < dataPostArray[i].servicios_activos.length; j++) {
                        valorExcell = valorExcell + dataPostArray[i].servicios_activos[j].valor
                        if (dataPostArray[i].servicios_activos[j].name === 'Eps') {
                            epsExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_activos[j].id_list)[0].name
                        } else if (dataPostArray[i].servicios_activos[j].name === 'Riesgo') {
                            riesgoExcell = dataPostArray[i].servicios_activos[j].id_list
                        } else if (dataPostArray[i].servicios_activos[j].name === 'Ccf') {
                            ccfExcell = this.gettersDatalist('list_ccf', dataPostArray[i].servicios_activos[j].id_list)[0].name
                        } else if (dataPostArray[i].servicios_activos[j].name === 'Afp') {
                            afpExcell = this.gettersDatalist('list_afp', dataPostArray[i].servicios_activos[j].id_list)[0].name
                        } else if (dataPostArray[i].servicios_activos[j].name === 'Traslado') {
                            trasladoExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_activos[j].id_list)[0].name
                        } else if (dataPostArray[i].servicios_activos[j].name !== 'Administración') {
                            otrosExcell = otrosExcell + ' ' + dataPostArray[i].servicios_activos[j].name
                        }
                    }
                    for (let j = 0; j < dataPostArray[i].servicios_nuevos.length; j++) {
                        if (dataPostArray[i].servicios_nuevos[j].name === 'Eps' && epsExcell === '') {
                            epsExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        } else if (dataPostArray[i].servicios_nuevos[j].name === 'Riesgo' && riesgoExcell === '') {
                            riesgoExcell = dataPostArray[i].servicios_nuevos[j].id_list
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        } else if (dataPostArray[i].servicios_nuevos[j].name === 'Ccf' && ccfExcell === '') {
                            ccfExcell = this.gettersDatalist('list_ccf', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        } else if (dataPostArray[i].servicios_nuevos[j].name === 'Afp' && afpExcell === '') {
                            afpExcell = this.gettersDatalist('list_afp', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        } else if (dataPostArray[i].servicios_nuevos[j].name === 'Traslado' && trasladoExcell === '') {
                            trasladoExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        } else if (dataPostArray[i].servicios_nuevos[j].name !== 'Administración' && !otrosExcell.includes(dataPostArray[i].servicios_nuevos[j].name)) {
                            otrosExcell = otrosExcell + ' ' + dataPostArray[i].servicios_nuevos[j].name
                            valorExcell = valorExcell + dataPostArray[i].servicios_nuevos[j].valor
                        }
                    }

                    let datosrazon = this.gettersDatalist('datos_razon', dataPostArray[i].id_datos_razon)[0]
                    dataToExport.push([datosrazon.name.toUpperCase(), dataPostArray[i].estado, this.gettersDatalist('list_documento', dataPostArray[i].id_list_documento)[0].name, dataPostArray[i].documento.toString(), dataPostArray[i].nombre1.toUpperCase(), (dataPostArray[i].nombre2 === null) ? dataPostArray[i].nombre2 : dataPostArray[i].nombre2.toUpperCase(), dataPostArray[i].apellido1.toUpperCase(), (dataPostArray[i].apellido2 === null) ? dataPostArray[i].apellido2 : dataPostArray[i].apellido2.toUpperCase(), dataPostArray[i].nacimiento, (dataPostArray[i].direccion === null) ? dataPostArray[i].direccion : dataPostArray[i].direccion.toUpperCase(), (dataPostArray[i].ciudad === null) ? dataPostArray[i].ciudad : dataPostArray[i].ciudad.toUpperCase(), dataPostArray[i].telefonos, (dataPostArray[i].email === null) ? dataPostArray[i].email : dataPostArray[i].email.toUpperCase(), this.gettersDatalist('datos_contacto', dataPostArray[i].id_datos_contacto)[0].name.toUpperCase(), this.gettersDatalist('datos_asesor', dataPostArray[i].id_datos_asesor)[0].name.toUpperCase(), (dataPostArray[i].cargo === null) ? dataPostArray[i].cargo : dataPostArray[i].cargo.toUpperCase(), dataPostArray[i].salario, dataPostArray[i].ingreso, this.gettersDatalist('list_mes', dataPostArray[i].mes_periodo)[0].name.toUpperCase() + '-' + dataPostArray[i].ano_periodo, epsExcell.toUpperCase(), this.gettersDatalist('list_arl', datosrazon.id_list_arl)[0].name.toUpperCase(), riesgoExcell, ccfExcell.toUpperCase(), afpExcell, trasladoExcell.toUpperCase(), otrosExcell.toUpperCase(), valorExcell])
                }

                let datae = XLSX.utils.json_to_sheet(dataToExport)
                datae['A1'].v = 'Razon Social'
                datae['B1'].v = 'Estado'
                datae['C1'].v = 'Tipo'
                datae['D1'].v = 'Documento'
                datae['E1'].v = 'Nombre1'
                datae['F1'].v = 'Nombre2'
                datae['G1'].v = 'Apellido1'
                datae['H1'].v = 'Apellido2'
                datae['I1'].v = 'Nacimiento'
                datae['J1'].v = 'Dirección'
                datae['K1'].v = 'Ciudad'
                datae['L1'].v = 'Telefonos'
                datae['M1'].v = 'Email'
                datae['N1'].v = 'Centro Trabajo'
                datae['O1'].v = 'Asesor'
                datae['P1'].v = 'Cargo'
                datae['Q1'].v = 'Salario'
                datae['R1'].v = 'Inicio Labores.'
                datae['S1'].v = 'Periodo Aporte'
                datae['T1'].v = 'Eps'
                datae['U1'].v = 'Arl'
                datae['V1'].v = 'Riesgo'
                datae['W1'].v = 'Ccf'
                datae['X1'].v = 'Afp'
                datae['Y1'].v = 'Traslado'
                datae['Z1'].v = 'Otros servicios'
                datae['AA1'].v = 'Valor'
                const workbook = XLSX.utils.book_new()
                const filename = 'listado' + this.fecha().fecha.hoy
                XLSX.utils.book_append_sheet(workbook, datae, filename)
                XLSX.writeFile(workbook, `${filename}.xlsx`)
            } else {
                this.statusDescargar = true
            }
        },
        async openPdf() {
            this.statusDescargar = false
            this.statusLoading = true
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            dataRoute.servicios = []
            for (let i = 0; i < filterKeys.length; i++) {
                if (this.filter[filterKeys[i]] !== '' && this.filter[filterKeys[i]] !== null) {
                    switch (filterKeys[i]) {
                        case 'name':
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].name])
                            break
                        case 'id_list':
                            dataRoute.servicios.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                        case 'estado':
                            dataRoute.estado = this.filter[filterKeys[i]]
                            break
                        default:
                            others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                            break
                    }
                }
            }
            dataRoute.others = others
            dataRoute.mes = this.mes.id
            dataRoute.ano = this.ano.id
            let dataPostArray = await this.getData({ route: 'get_excelllistados', data: dataRoute })
            var html = '<div class="p-3">'
            if (this.filter.id_datos_razon === null) {
                html += '<h5 class="text-center m-2">LISTADO</h5>'
            } else {
                html += '<h5 class="text-center m-2">LISTADO DE ' + this.gettersDatalist('datos_razon', this.filter.id_datos_razon.id)[0].name + ' </h5>'
            }
            html += '<table class="table table-bordered table-sm table-pdf" ><thead class="thead-light"><tr> <th >#</th><th>Documento</th><th >Nombres</th><th >EPS</th><th >R</th><th >CCF</th><th >AFP</th><th >Otros</th>    <th >Novedad</th></tr></thead><tbody>'
            var prueba = 0
            for (let i = 0; i < dataPostArray.length; i++) {
                let epsExcell = ''
                let riesgoExcell = ''
                let ccfExcell = ''
                let afpExcell = ''
                let trasladoExcell = ''
                let otrosExcell = ''

                for (let j = 0; j < dataPostArray[i].servicios_activos.length; j++) {
                    if (dataPostArray[i].servicios_activos[j].name === 'Eps') {
                        epsExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_activos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_activos[j].name === 'Riesgo') {
                        riesgoExcell = dataPostArray[i].servicios_activos[j].id_list
                    } else if (dataPostArray[i].servicios_activos[j].name === 'Ccf') {
                        ccfExcell = this.gettersDatalist('list_ccf', dataPostArray[i].servicios_activos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_activos[j].name === 'Afp') {
                        afpExcell = this.gettersDatalist('list_afp', dataPostArray[i].servicios_activos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_activos[j].name === 'Traslado') {
                        trasladoExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_activos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_activos[j].name !== 'Administración') {
                        otrosExcell = otrosExcell + ' ' + dataPostArray[i].servicios_activos[j].name
                    }
                }
                for (let j = 0; j < dataPostArray[i].servicios_nuevos.length; j++) {
                    if (dataPostArray[i].servicios_nuevos[j].name === 'Eps' && epsExcell === '') {
                        epsExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_nuevos[j].name === 'Riesgo' && riesgoExcell === '') {
                        riesgoExcell = dataPostArray[i].servicios_nuevos[j].id_list
                    } else if (dataPostArray[i].servicios_nuevos[j].name === 'Ccf' && ccfExcell === '') {
                        ccfExcell = this.gettersDatalist('list_ccf', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_nuevos[j].name === 'Afp' && afpExcell === '') {
                        afpExcell = this.gettersDatalist('list_afp', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_nuevos[j].name === 'Traslado' && trasladoExcell === '') {
                        trasladoExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                    } else if (dataPostArray[i].servicios_nuevos[j].name !== 'Administración' && !otrosExcell.includes(dataPostArray[i].servicios_nuevos[j].name)) {
                        otrosExcell = otrosExcell + ' ' + dataPostArray[i].servicios_nuevos[j].name
                    }
                }

                html += '<tr>'
                html += '<td>' + (i + 1) + '</td>'
                html += '<td>' + this.gettersDatalist('list_documento', dataPostArray[i].id_list_documento)[0].name + ' ' + dataPostArray[i].documento + '</td>'
                html += '<td class="text-uppercase">' + dataPostArray[i].name + '</td>'

                html += '<td class="text-uppercase">' + epsExcell + '</td>'
                html += '<td class="text-uppercase">' + riesgoExcell + '</td>'
                html += '<td class="text-uppercase">' + ccfExcell + '</td>'
                html += '<td class="text-uppercase">' + afpExcell + '</td>'
                html += '<td class="text-uppercase">' + trasladoExcell + ' ' + otrosExcell + '</td>'
                html += '<td>' + dataPostArray[i].estado + '</td>'
                html += '</tr>'
            }

            html += '</tbody></table></div>'
            const options = {
                margin: 0.2,
                filename: 'listado.pdf',
                image: { type: 'jpeg', quality: 0.8 },
                pagebreak: { mode: ['avoid-all'] },
                html2canvas: { scale: 1 },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait'
                }
            };
            if (dataPostArray.length > 400) {
                await html2pdf(html, options)
            } else {
                await html2pdf().set(options).from(html).outputPdf('dataurlnewwindow');
            }

            this.statusLoading = false
            return true
        }
    },
}